import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Checkbox,
  Typography,
  Divider,
  Spin,
  Row,
  Card,
} from "antd";
import { useNavigate } from "react-router-dom";
import { useForm } from "antd/es/form/Form";
import useSuccessErrorModal from "../../hooks/successErrorModal/useSuccessErrorModal";
import PageRoutes from "../../utils/routes";
import useAuthService from "../../services/useAuthService";
import useManageUuid from "../../hooks/useManageUuid";
import { GoogleLogin } from "@react-oauth/google";

const LoginPersonnel = () => {
  const [form] = useForm();
  const navigate = useNavigate();
  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();
  const { personnelLogin, isPersonnelLoginLoading, personnelGoogleLogin } =
    useAuthService();
  const uuid = useManageUuid();

  const handleGoogleSuccess = (credentialResponse) => {
    console.log("credential response is", credentialResponse);
    return;
    const requestBody = {
      deviceUID: uuid,
      idToken: credentialResponse.credential,
    };

    personnelGoogleLogin.mutate(requestBody);
  };

  const handleGoogleError = () => {
    showModal({
      type: "error",
      title: "Google ile Giriş Başarısız",
      content:
        "Google ile giriş yapılırken bir hata oluştu. Lütfen tekrar deneyin.",
    });
  };

  const onSubmit = (values) => {
    const requestBody = {
      phoneNumber: values.phoneNumber,
      password: values.password,
      countryCode: 90,
      deviceUID: uuid,
    };
    personnelLogin.mutate(requestBody);
  };

  return (
    <>
      <Spin
        spinning={isPersonnelLoginLoading || personnelGoogleLogin.isPending}>
        <Card
          style={{
            maxWidth: 450,
            margin: "auto",
            marginTop: 15,
            padding: "24px",
            boxShadow: "0px 5px 15px hsla(220, 30%, 5%, 0.05)",
          }}>
          <Typography.Title level={2} style={{ textAlign: "center" }}>
            Personel Giriş
          </Typography.Title>
          <Form
            form={form}
            layout="vertical"
            onFinish={onSubmit}
            style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <Form.Item
              label="Telefon Numarası"
              name="phoneNumber"
              rules={[
                { required: true, message: "Lütfen telefon numarası giriniz" },
              ]}>
              <Input prefix="90" placeholder="5XX XXX XX XX" />
            </Form.Item>

            <Form.Item
              label="Şifre"
              name="password"
              rules={[{ required: true, message: "Lütfen şifrenizi giriniz" }]}>
              <Input.Password placeholder="••••••" />
            </Form.Item>
            <Row justify="space-between">
              <Form.Item name="newsletter" valuePropName="checked">
                <Checkbox>Beni Hatırla</Checkbox>
              </Form.Item>
              <Typography.Text
                style={{ display: "block", textAlign: "center" }}>
                <Button
                  type="link"
                  onClick={() => navigate(PageRoutes.forgotPasswordWorker)}>
                  Şifremi Unuttum
                </Button>
              </Typography.Text>
            </Row>

            <Button
              type="primary"
              htmlType="submit"
              block
              disabled={isPersonnelLoginLoading}
              loading={isPersonnelLoginLoading}>
              Giriş Yap
            </Button>

            <Divider style={{ margin: "12px 0" }}>veya</Divider>

            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
            />
          </Form>

          <Divider />

          <Typography.Text style={{ display: "block", textAlign: "center" }}>
            Hesabınız Yok mu?
            <Button
              type="link"
              onClick={() => navigate(PageRoutes.signupWorker)}>
              Kayıt Ol
            </Button>
          </Typography.Text>
        </Card>
      </Spin>
      <ModalComponent />
    </>
  );
};

export default LoginPersonnel;
